<template>
  <div class="a-cover flex flex-col bg-primary overflow-auto">
    <!-- <BgVideo v&#45;if="bgVideo" :src="bgVideo" /> -->

    <a
      :href="'https://www.dundee.ac.uk'"
      aria-label="University of Dundee website"
      target="_blank"
      class="absolute top-3 left-3 md:top-8 md:left-8 block focus-a z-20"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="96" height="32" viewBox="0 0 96 32" v-bind:svg-inline="''" v-bind:class="'h-10 md:h-12 w-auto'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#fff" d="M0 .914v15.082c0 11.705 11.444 16.005 11.444 16.005s11.444-4.3 11.444-16.005V.914zm17.961 5.962a1.547 1.547 0 011.469-.853h-.004c.182.033.34.117.464.236a.889.889 0 01.097-.653l-.002.004a1.558 1.558 0 011.377-.701h-.004c.007 0 .014.002.02.005a.04.04 0 01.019.033.038.038 0 01-.005.019l-2.229 3.861a.04.04 0 01-.033.019.038.038 0 01-.019-.005.626.626 0 01-.194-.835l-.002.003a.62.62 0 01.202-.211l.002-.001a1.689 1.689 0 01-1.155-.849l-.004-.009c-.006-.009-.009-.02-.009-.031s.003-.022.009-.031zm.826 2.604l-.802 1.387c-1.876-1.1-4.132-1.75-6.54-1.75s-4.663.65-6.602 1.783l.062-.033-.802-1.388c2.107-1.236 4.639-1.965 7.342-1.965s5.236.73 7.412 2.003l-.07-.038zM14.27 5.241l.145-.542a.223.223 0 01.277-.158h-.002l.895.24.24-.895a.224.224 0 01.277-.159H16.1l.542.146a.223.223 0 01.158.276v-.002l-.24.895.895.24a.224.224 0 01.159.277v-.002l-.145.542a.223.223 0 01-.277.158h.002l-.895-.24-.325 1.215a.223.223 0 01-.277.158h.002l-.541-.146a.224.224 0 01-.159-.277v.002l.326-1.215-.895-.24a.224.224 0 01-.159-.276v.002zm-4-1.037a.868.868 0 01.525-.025l-.006-.001a.893.893 0 01-.243-.613v-.001a1.548 1.548 0 01.858-1.304l.009-.004a.062.062 0 01.063.001c.493.248.833.736.867 1.307v.004a.89.89 0 01-.243.609.9.9 0 01.525.028l-.006-.002a1.547 1.547 0 01.842 1.475v-.004.003a.055.055 0 01-.03.05 1.677 1.677 0 01-1.444.16l.012.004a.6.6 0 01.071.286v.001a.624.624 0 01-1.248 0c0-.104.026-.203.072-.289l-.002.003a1.676 1.676 0 01-1.438-.168l.007.004a.059.059 0 01-.031-.05v-.003a1.546 1.546 0 01.834-1.467l.009-.004zM5.432 5.281l.895-.24-.24-.895a.225.225 0 01.157-.275h.002l.542-.145a.223.223 0 01.274.157v.002l.24.895.895-.24a.223.223 0 01.274.157v.002l.145.541a.224.224 0 01-.157.275h-.002l-.895.24.326 1.215a.224.224 0 01-.157.274h-.002l-.542.146a.226.226 0 01-.275-.157v-.002l-.325-1.215-.895.24a.224.224 0 01-.274-.157v-.002l-.146-.542a.224.224 0 01.158-.276h.002zM1.51 4.916a.041.041 0 01.019-.005l.072-.002c.542 0 1.019.277 1.298.697l.004.006a.883.883 0 01.093.655l.001-.006a.885.885 0 01.457-.235l.005-.001.083-.002c.602 0 1.123.344 1.378.846l.004.009c.006.009.009.02.009.031s-.003.022-.009.031a1.689 1.689 0 01-1.148.856l-.011.002a.608.608 0 01.203.21l.002.003a.624.624 0 01-.192.831l-.002.001a.041.041 0 01-.019.005.04.04 0 01-.033-.019L1.497 4.967a.036.036 0 01-.006-.02.04.04 0 01.017-.032zm17.029 21.265a18.43 18.43 0 01-1.705 1.736l-.018.016a20.587 20.587 0 01-5.24 3.397l-.13.052a20.63 20.63 0 01-5.363-3.441l.021.018a18.376 18.376 0 01-1.733-1.755l-.02-.024 7.095-5.444L.574 12.393h21.744l-10.872 8.343zM92.333 18.082l.059-.001c.874 0 1.582.708 1.582 1.582v.003h-3.429a1.774 1.774 0 011.762-1.584h.027-.001zm.058-1.293c-2.049 0-3.429 1.526-3.429 3.705 0 2.295 1.467 3.705 3.458 3.705a2.974 2.974 0 002.914-1.854l.007-.02-1.22-.668a1.713 1.713 0 01-1.718 1.206h.004c-1.046 0-1.816-.756-1.918-2.136h5.027v-.422c.029-1.961-1.119-3.516-3.122-3.516zm-7.582 1.294l.059-.001c.874 0 1.582.708 1.582 1.582v.003h-3.429a1.774 1.774 0 011.762-1.584h.027-.001zm.058-1.293c-2.049 0-3.429 1.526-3.429 3.705 0 2.295 1.467 3.705 3.458 3.705a2.974 2.974 0 002.914-1.854l.007-.02-1.22-.668a1.713 1.713 0 01-1.633 1.208l-.085-.002h.004c-1.046 0-1.816-.756-1.918-2.136h5.027v-.422c.029-1.961-1.119-3.516-3.122-3.516zm-8.179 6.057c-1.148 0-1.889-.828-1.889-2.354s.741-2.354 1.873-2.354c1.075 0 1.873.654 1.991 1.991v.698c-.116 1.366-.901 2.019-1.976 2.019zm1.975-8.542v3.501h-.102a2.41 2.41 0 00-2.143-1.017h.008c-1.714 0-3.167 1.395-3.167 3.705 0 2.295 1.453 3.705 3.185 3.705a2.397 2.397 0 002.131-1.024l.005-.008h.087v.886h1.523v-9.952zM69.54 16.79h-.046c-.853 0-1.606.428-2.055 1.082l-.005.008h-.13l-.058-.886h-1.409v7.061h1.526v-3.661a2.395 2.395 0 01.442-1.62l-.005.007a1.8 1.8 0 011.353-.61h.029-.001c.886 0 1.351.465 1.351 1.715v4.17h1.526v-4.694c0-1.932-1.177-2.572-2.513-2.572zm-6.901.203v3.661a2.395 2.395 0 01-.442 1.62l.005-.007a1.8 1.8 0 01-1.352.61h-.029.001c-.886 0-1.351-.465-1.351-1.714v-4.17h-1.526v4.691c0 1.932 1.177 2.572 2.513 2.572h.047c.853 0 1.606-.428 2.055-1.082l.005-.008h.13l.058.886h1.409v-7.059zm-12.291-.828h1.264c2.528 0 3.414 1.104 3.414 3.225 0 2.15-.901 3.283-3.414 3.283h-1.264zm1.278-1.365h-2.891v9.255h2.891c3.443 0 5.012-1.802 5.012-4.664 0-2.833-1.569-4.591-5.012-4.591zm-7.058 1.077c.304.003.596.049.873.131l-.022-.006v-1.318a3.847 3.847 0 00-.872-.098l-.122.002h.006c-1.166 0-2.498.549-2.498 2.538v.26h-1.07v1.166h1.07v5.503h1.427v-5.503h1.784v-1.166H43.36v-.125c0-.947.425-1.386 1.208-1.386zm-5.86 4.815c0 1.413-.673 2.237-1.825 2.237-1.124 0-1.825-.823-1.825-2.237s.7-2.237 1.825-2.237c1.153 0 1.825.823 1.825 2.237zm1.454 0c0-2.141-1.331-3.497-3.28-3.497-1.936 0-3.28 1.358-3.28 3.497s1.344 3.497 3.28 3.497c1.948 0 3.28-1.358 3.28-3.497zM95.618 3.109H94.02l-1.845 5.448-1.831-5.448h-1.743l2.708 7.094-.964 2.626h1.584l3.153-8.296-.014.014zm-9.343 4.33V4.342h1.729V3.109h-1.743V1.148l-1.511.187v1.773h-.915v1.234h.915v3.24c0 2.092 1.366 2.685 2.586 2.685l.077.001c.334 0 .658-.043.967-.123l-.027.006V8.756a3.05 3.05 0 01-.873.13h-.001c-.784 0-1.206-.465-1.206-1.453zm-3.691-4.336h-1.526v7.061h1.526zM82.802.98V.955a.98.98 0 10-1.962 0v.026V.98a.982.982 0 001.962.001V.98zm-8.136 6.945l-.77 1.017a3.349 3.349 0 002.87 1.366h-.008c1.642 0 2.761-.886 2.761-2.252 0-1.322-1.09-1.831-2.339-2.165-.857-.218-1.54-.421-1.54-1.002 0-.407.375-.726 1.104-.726a2.644 2.644 0 011.915.898l.003.003.756-1.075a3.534 3.534 0 00-2.57-1.105l-.079.001h.004c-1.569 0-2.645.812-2.645 2.107 0 1.337 1.09 1.831 2.427 2.165.959.25 1.467.508 1.467 1.062 0 .523-.48.828-1.249.828h-.011c-.87 0-1.637-.44-2.09-1.11l-.006-.009zm-1.772-5.011a2.123 2.123 0 00-1.868 1.236l-.005.013h-.102l-.072-1.046h-1.424v7.046h1.54V6.232a1.674 1.674 0 011.717-1.859h-.003a1.287 1.287 0 01.575.091l-.009-.003.116-1.482a1.31 1.31 0 00-.396-.06l-.072.002h.003zm-8.151 1.285l.059-.001c.874 0 1.582.708 1.582 1.582v.003h-3.429a1.774 1.774 0 011.762-1.584h.026-.001zm.058-1.293c-2.049 0-3.429 1.526-3.429 3.705 0 2.295 1.467 3.705 3.458 3.705a2.974 2.974 0 002.914-1.854l.007-.02-1.22-.668a1.713 1.713 0 01-1.633 1.208l-.085-.002h.004c-1.046 0-1.816-.756-1.918-2.136h5.027v-.421c.029-1.961-1.119-3.516-3.122-3.516zm-5.519.204l-1.845 5.448-1.832-5.449h-1.743l2.685 7.061h1.642l2.685-7.061zm-6.581 0h-1.529v7.061h1.526zm.218-2.123V.962a.98.98 0 10-1.962 0v.026-.001a.982.982 0 001.962.001V.987zm-6.103 1.919h-.046c-.853 0-1.606.428-2.055 1.082l-.005.008h-.13l-.058-.886h-1.409v7.061h1.526V6.51a2.395 2.395 0 01.442-1.62l-.005.007a1.8 1.8 0 011.352-.61h.029-.001c.886 0 1.351.465 1.351 1.714v4.17h1.526V5.478c0-1.932-1.177-2.571-2.513-2.571zM35.441 6.379V.916h-1.613v5.506c0 2.543 1.191 4.025 3.719 4.025 2.498-.014 3.734-1.453 3.734-4.025V.916h-1.613v5.463c0 1.729-.566 2.615-2.123 2.615s-2.107-.886-2.107-2.615zM56.354 5.074z"/></svg>
    </a>

    <div
      class="absolute top-0 right-0 w-55vw h-50vh md:60vw md:h-50vh lg:h-70vh bg-accent-1 shadow-2xl"
      :style="
        !background.upper.isVideo
          ? `background-image: url(${background.upper.src})`
          : ''
      "
    >
      <BgVideo v-if="background.upper.isVideo" :src="background.upper.src" />
    </div>

    <div class="h-20vh md:h-30vh w-full" />

    <BtnBgVideo class="absolute top-3 right-3 md:top-8 md:right-8" />

    <div class="relative flex-j flex-grow">
      <div
        :style="
          !background.lower.isVideo
            ? `background-image: url(${background.lower.src})`
            : ''
        "
        class="y-inset left-0 w-60vw bg-full bg-accent-2 shadow-2xl"
      >
        <BgVideo v-if="background.lower.isVideo" :src="background.lower.src" />
      </div>

      <div
        class="relative px-4 md:px-8 pt-12 pb-8 h-96 xs-l:py-2 xs-l:h-auto lg:inline-flex lg:flex-col lg:justify-between md:h-50vh bg-white shadow-2xl"
      >
        <h1
          class="text-3xl md:text-6xl leading-tight w-64 md:w-84"
          v-html="options.heading"
        />
        <ul class="relative lg:flex-a mt-8">
          <li class="">
            <Button
              id="welcome-video-btn"
              ref="welcomeVideoBtn"
              type="button"
              icon="ArrowIcon"
              text="Watch intro video"
              class="btn-lg btn-primary mb-2 md:mb-6 mx-auto lg:mr-6"
              @buttonClick="videoOpen = true"
            />
          </li>
          <li class="">
            <Button
              icon="ArrowIcon"
              text="Explore for yourself"
              :path="{ name: 'campus' }"
              class="btn-lg btn-primary mb-2 md:mb-6 mx-auto lg:mr-6"
            />
          </li>
          <li class="">
            <Button
              icon="ArrowIcon"
              text="Take a guided tour"
              :path="guidedTourPath"
              class="btn-lg btn-primary mb-2 md:mb-6 mx-auto"
            />
          </li>
        </ul>
      </div>
    </div>

    <FocusLock :disabled="!videoOpen">
      <Transition name="fade">
        <section
          v-if="videoOpen"
          aria-modal="true"
          aria-label="options.video.title"
          class="a-cover md:flex-c py-24 md:py-7vw lg:px-20vw bg-black-85 z-10 overflow-y-auto scrollbar"
          @click.self="videoOpen = false"
        >
          <Video :post="options.video" />

          <Button
            type="button"
            aria="Close"
            icon="CloseIcon"
            :iconsize="mobile ? '2rem' : '2.2rem'"
            iconcolor="white"
            class="absolute top-4 md:top-8 right-3vw md:right-8"
            @buttonClick="videoOpen = false"
          />
        </section>
      </Transition>
    </FocusLock>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { gsap } from 'gsap'
import BgVideo from '@/components/BgVideo.vue'
import BtnBgVideo from '@/components/buttons/BtnBgVideo.vue'
import Button from '@/components/buttons/Button.vue'
import FocusLock from 'vue-focus-lock'
const Video = () => import('@/components/Video.vue')

export default {
  name: 'Home',

  components: {
    BgVideo,
    BtnBgVideo,
    Button,
    Video,
    FocusLock
  },

  data() {
    return {
      videoOpen: false
    }
  },

  computed: {
    ...mapState(['touch', 'mobile', 'phone']),
    ...mapGetters(['posts', 'options', 'categories', 'guidedtour']),

    welcomeVideoBtn() {
      return this.$refs.welcomeVideoBtn
    },

    bgVideo() {
      return this.options?.video_bg?.url
    },

    image() {
      const srcLg = this.options?.image?.sizes?.large
      const srcSm = this.options?.image?.sizes?.medium
      return this.phone ? srcSm : srcLg
    },

    background() {
      const background = this.options.background
      const upper = {
        src:
          background.upper?.video?.url || background.upper?.image?.sizes?.large,
        isVideo: background.upper?.video
      }

      const lower = {
        src:
          background.lower?.video?.url || background.lower?.image?.sizes?.large,
        isVideo: background.lower?.video
      }

      return {
        upper: upper,
        lower: lower
      }
    },

    guidedTourPath() {
      const firstStop = this.guidedtour?.children[0]

      if (firstStop) {
        return {
          name: 'guided-tour'
        }
      }

      return { name: 'home' }
    }
  },

  mounted() {
    // this.homeAnimation()
  },

  methods: {
    homeAnimation() {
      const tl = gsap.timeline({ delay: 1 })
      tl.from('#gsap-title-the', {
        x: '-100vw',
        ease: 'bounce.out',
        duration: 2.2
      })
      tl.from(
        '#gsap-title-original',
        { x: '100vw', ease: 'bounce.out', duration: 2 },
        0.2
      )
      tl.from(
        '#gsap-title-red',
        { x: '-100vw', ease: 'bounce.out', duration: 2.5 },
        0.1
      )
      tl.from(
        '#gsap-title-brick',
        { x: '100vw', ease: 'bounce.out', duration: 2.3 },
        0.3
      )
      tl.from(
        '#gsap-blue-box',
        { backgroundColor: 'transparent', duration: 0.9 },
        2.5
      )
      tl.from('#gsap-introduction', { opacity: 0 }, 3.2)
      tl.from('.gsap-btn', { opacity: 0, stagger: 0.4, duration: 0.3 }, 3.5)
    }
  }
}
</script>
